module.exports = __webpack_public_path__ + "img/title.ad8350e1.png";